import React, { useState, Fragment } from "react";
import FilterPanelContent from "./FilterPanelContent";
import { connect } from "react-redux";
import { iRootState, Dispatch } from "../../../rematch/store";
import { useTranslation } from "react-i18next";

import filterIcon from "../../../icons/IconFilter.png";
import filterIconHover from "../../../icons/IconFilterHover.png";
import filterIconPressed from "../../../icons/IconFilterPressed.png";
import { ModalBackdrop, SettingsSpan } from "../common/StyledComponents";
import { IconSettingsButton32x32 } from "../common/Buttons";
import { FlexItem } from "./FiltersCommon";
import { IFilter, IFilterGroup } from "../../../backend/interfaces/filters/IFilter";
import SavedFilterDropdown from "./SavedFilterDropdown";
import { SelectOption } from "../common/EditValueListProperty";


interface IFilterPanelProps {
  viewIndex: number;
  enabledFilters: number[][];
  isFiltersEnabled: (viewIndex: number) => boolean;
  isTemporaryFilter: (viewIndex: number) => boolean;
  getFilters: (viewIndex: number) => IFilterGroup[];
  toggleEnabled: (viewIndex: number, filterName: string, ownerId: number) => void;
}

const FilterPanel = (props: IFilterPanelProps) => {

  const { t } = useTranslation();

  const [isPanelVisible, setIsPanelVisible] = useState(false);
  
  const togglePanel = () => {
    if (isPanelVisible) {
      setIsPanelVisible(false);
    } else {
      setIsPanelVisible(true);
    }
  };

  const isFilterActive = () => {
    return props.isFiltersEnabled(props.viewIndex) || props.isTemporaryFilter(props.viewIndex);
  };

  const propertyOptions: SelectOption[] = [];

  let defaultSelectedOptions: SelectOption[] = [];
  
  props.getFilters(props.viewIndex)?.forEach((filter: IFilterGroup | IFilter, index: number) => {

    let selectOption;

    if ( ! filter.hasOwnProperty('conditionType') ) {
      selectOption = { value: (filter as IFilter).value.toString(), label: filter.name };
    } else {
      selectOption = { value: filter.name.toString(), label: filter.name };
    }

    const checked = props.enabledFilters[props.viewIndex]?.includes(index);
    if ( checked ) { 
      defaultSelectedOptions.push( selectOption ); 
    }

    propertyOptions.push( selectOption );
  });

  return (
    <Fragment>
      <div style={{ display: 'flex', flex: '0 0 10%'}}>
        <FlexItem style={{marginLeft: 8}} width={32}>
          <IconSettingsButton32x32 image={isFilterActive() ? filterIconPressed : filterIcon} imageHover={filterIconHover} imagePressed={filterIconPressed} onClick={togglePanel} />
        </FlexItem>
        <SettingsSpan style={{ height: '48px', lineHeight: '48px' }}>{t("filter.paneltext")}</SettingsSpan>
      </div>
      <div style={{ display: 'flex', flex: '1', overflowX: 'auto', height: '48px', lineHeight: '48px' }}>

        <SavedFilterDropdown viewIndex={props.viewIndex} />

      </div>
      {isPanelVisible && 
      <Fragment>
        <FilterPanelContent closePanel={togglePanel} viewIndex={props.viewIndex} />
        <ModalBackdrop onClick={togglePanel}></ModalBackdrop>
      </Fragment>}
    </Fragment>
  );
};

export default connect(
  (state: iRootState) => ({
    isFiltersEnabled: (viewIndex: number): boolean => state.filters.enabledPanelFilters[viewIndex]?.length > 0,
    isTemporaryFilter: (viewIndex: number): boolean => state.filters.temporaryFilters[viewIndex] !== null,
    getFilters: (viewIndex: number) => state.filters.panelFilters[viewIndex] ?? [],
    enabledFilters: state.filters.enabledPanelFilters,
  }),
  (dispatch: Dispatch) => ({
    toggleEnabled: (viewIndex: number, filterName: string, ownerId: number) => dispatch.filters.toggleEnabled({ viewIndex, filterName, ownerId }),
  })
)(FilterPanel);
